import { render, staticRenderFns } from "./SubscriptionForm.Promo.vue?vue&type=template&id=0a8dc168&scoped=true&"
import script from "./SubscriptionForm.Promo.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Promo.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Promo.vue?vue&type=style&index=0&id=0a8dc168&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8dc168",
  null
  
)

export default component.exports